module.exports = __webpack_public_path__ + "img/1.c43207b6.jpg";